import React, { useState } from 'react';
import { Button as AdminButton, useRecordContext, useResourceContext, useTranslate } from 'react-admin';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/Error';
import PublishIcon from '@mui/icons-material/Publish';
import { FUNCTION_URL } from '../../../Constants/index';
import { DropzoneDialog } from 'react-mui-dropzone';
import ResultDialog from '../../../Utilities/ResultDialog';


function UploadFileDeviceScaricato() {
    const [open, setOpen] = useState(false);
    const [resultDialogOpen, setResultDialogOpen] = useState(false);
    const [resultDialogHeaders, setResultDialogHeaders] = useState([]);
    const [resultDialogRows, setResultDialogRows] = useState([[]]);
    const [resultLoading, setResultLoading] = useState(false);

    const resource = useResourceContext();
    const translate = useTranslate();
    const record = useRecordContext();

    const handleClose = () => {
        setOpen(false);
    }

    const handleResultClose = () => {
        setResultDialogOpen(false);
        setResultDialogRows([]);
        setResultDialogHeaders([]);
        setResultLoading(false);
    }

    const handleSave = async (files) => {
        var startTime = new Date();
        setOpen(true);
        setResultDialogOpen(true);
        setResultLoading(true);

        var resultArray = [];
        var i = 0;
        for (i = 0; i < files.length; i++) {
            let dataBase64 = await readFileAsync(files[i]);
            let data = JSON.stringify({
                resource: resource,
                serial_number: record.serial_number_tim,
                id: record.id,
                filename: files[i].name,
                data: dataBase64
            });

            await fetch(FUNCTION_URL + '/uploadfile', {
                method: 'POST',
                headers: {
                    'x-zumo-auth': localStorage.getItem('auth-token')
                },
                body: data
            })
                .then(response => {
                    if (response.status === 200) {
                        resultArray.push([files[i].name, <DoneIcon />])
                    }
                    else {
                        resultArray.push([files[i].name, <ErrorIcon />])
                    }
                })
                .catch(error => {
                    console.log(error);
                    return error;
                });
            if (i === files.length - 1) {
                setResultDialogOpen(true);
                setResultDialogRows(resultArray);
                setResultDialogHeaders(["File", "Risultato"]);
                setResultLoading(false);
            }
        }
        var endTime = new Date();
        console.log(timeElpased(startTime, endTime));
    }

    const handleOpen = () => {
        setOpen(true);
    }

    const timeElpased = (starTime, endTime) => {
        var timeDiff = endTime - starTime;
        timeDiff /= 1000;
        var seconds = Math.round(timeDiff);
        return seconds;
    }
    
    const readFileAsync = (file) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
    
            reader.onload = () => {
                resolve(reader.result);
            };
    
            reader.onerror = reject;
    
            reader.readAsDataURL(file);
        })
    }

    return (
        <div>
            <AdminButton label='tim.uploadfile.button_label' onClick={handleOpen} >
                <PublishIcon />
            </AdminButton>
            <DropzoneDialog
                open={open}
                onSave={handleSave}
                dropzoneText={translate('tim.uploadfile.dragOrClick')}
                filesLimit={3}
                showPreviews={true}
                maxFileSize={5000000}
                onClose={handleClose}
            />
            <ResultDialog
                open={resultDialogOpen}
                rows={resultDialogRows}
                headers={resultDialogHeaders}
                loading={resultLoading}
                title="Risultati"
                onClose={handleResultClose} >
                {!resultLoading && <AdminButton label='tim.uploadfile.close' onClick={handleResultClose} color="primary"></AdminButton>}
            </ResultDialog>
        </div>
    );
}

export default UploadFileDeviceScaricato;